/**
 * 서버(UTC, 타임존 표시 없음)에서 온 날짜 문자열을 로컬(KST) 기준으로 파싱합니다.
 */
export function parseUTCDate(value?: string | Date | null): Date | null {
  if (!value) return null
  try {
    if (value instanceof Date) return value
    // 타임존 표시가 없으면 UTC로 간주하여 Z를 붙임
    const raw = value.endsWith('Z') || value.includes('+') || value.includes('-', 10) ? value : value + 'Z'
    const d = new Date(raw)
    return isNaN(d.getTime()) ? null : d
  } catch {
    return null
  }
}

/**
 * 짧은 날짜시간 포맷: 2026.04.07 15:30
 */
export function formatShortDatetime(value?: string | Date | null): string {
  const d = parseUTCDate(value)
  if (!d) return '-'
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  const hh = String(d.getHours()).padStart(2, '0')
  const mm = String(d.getMinutes()).padStart(2, '0')
  return `${y}.${m}.${day} ${hh}:${mm}`
}

/**
 * 짧은 날짜 포맷: 2026/04/07
 */
export function formatShortDate(value?: string | Date | null): string {
  const d = parseUTCDate(value)
  if (!d) return '-'
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}/${m}/${day}`
}

/**
 * 로케일 기반 날짜시간: 브라우저 로케일에 맞춤
 */
export function formatLocaleDatetime(value?: string | Date | null): string {
  const d = parseUTCDate(value)
  if (!d) return ''
  return d.toLocaleString()
}

/**
 * 날짜만 (시각 제외): 2026. 9. 3.
 *
 * ZIP 보관 기한처럼 하루 단위로만 의미가 있는 값에 쓴다 — 시:분까지 붙이면
 * 정밀해 보이지만 실제로는 housekeeping 이 하루 한 번 돌아 의미가 없다.
 */
export function formatLocaleDateOnly(value?: string | Date | null): string {
  const d = parseUTCDate(value)
  if (!d) return '-'
  return d.toLocaleDateString()
}

/**
 * 초까지: 2026-09-04 16:26:01
 *
 * 사고 시각처럼 초가 의미 있는 값에 쓴다 (카나리아 검사, 마지막 수집 시각 등).
 */
export function formatDatetimeWithSeconds(value?: string | Date | null): string {
  const d = parseUTCDate(value)
  if (!d) return '—'
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  const hh = String(d.getHours()).padStart(2, '0')
  const mi = String(d.getMinutes()).padStart(2, '0')
  const ss = String(d.getSeconds()).padStart(2, '0')
  return `${y}-${m}-${day} ${hh}:${mi}:${ss}`
}
